var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Bemerkungen zum Unternehmen")]),(_vm.note.length)?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.note))]):_c('p',{staticClass:"ui info message"},[_vm._v("Keine Bemerkung vorhanden")])])
}
var staticRenderFns = []

export { render, staticRenderFns }